<template>
  <div class="Checkbox">
      <input 
        :id="id" 
        class="Checkbox-input" 
        type="checkbox" 
        :checked="isChecked" 
        :value="value" 
        @change="updateInput"
        >
      <label class="Checkbox-label" :for="id">
          {{label}}
      </label>
  </div>
</template>

<script>
import uniqueId from 'lodash/uniqueId';

export default {
  emits: ['update:modelValue'],
  
  data() {
    return {
      id: uniqueId('checkbox-')
    };
  },
  
  computed: {
    isChecked() {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.value)
      }
      // Note that `true-value` and `false-value` are camelCase in the JS
      return this.modelValue === this.trueValue
    }
  },

  props: {
    value: { type: String },
    modelValue: { default: "" },
    label: { type: String, required: true},
    trueValue: { default: true },
    falseValue: { default: false },
    label: {
      type: String,
      default: ""
    }
  },

  methods: {
    updateInput(event) {
      let isChecked = event.target.checked;

      if (this.modelValue instanceof Array) {
        let newValue = [...this.modelValue];

        if (isChecked) {
          newValue.push(this.value);
        } else {
          newValue.splice(newValue.indexOf(this.value), 1);
        }

        this.$emit('update:modelValue', newValue);
      } else {
        this.$emit('update:modelValue', isChecked ? this.trueValue : this.falseValue);
      }
    }
  }
};
</script>

<style scoped></style>
